module.exports = __webpack_public_path__ + "media/images/emblems/Villars-sous-Yens-coat_of_arms-b092c3a98bd270c196b22a83b6de2139.svg";